export default __webpack_public_path__ + "static/media/coder.6dfd0778.png";